/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
/* eslint-disable react/jsx-pascal-case */
import TeamCard from "./TeamCard";
import { Api } from "../../../../api";
import Topbar from "../../../PulseSurvey/Topbar";
import React, { useEffect, useState } from "react";
import Icons from "../../../../component/svgs/icons";
import { Link, useNavigate } from "react-router-dom";
import Dots from "../../../../assets/images/Dots.svg";
import { CompanyApi } from "../../../../api/companyApi";
import Loader from "../../../../component/common/Loader";
import InfoPopup from "../../../../component/common/InfoPopup";
import ActiveDots from "../../../../assets/images/active-dots.svg";
import SearchInput from "../../../../component/common/Input/SearchInput";
import {
  errorToast,
  getPathForSurvey,
  successToast,
} from "../../../../utils/helper";
import DashboardInfoCard from "../../../../component/common/DashboardInfoCard";

const ChallangesDashboard = () => {
  const rewardList = [
    {
      id: 1,
      title: "Mindful Mornings",
      description:
        "Complete a morning meditation ritual for 7 days straight - 50pts",
    },
    {
      id: 2,
      title: "Invite a friend",
      description: "If your friend signs up - 500pts",
    },
    {
      id: 3,
      title: "Meditations",
      description: "Use 100 WELLPOINTS to save 20% on your next session",
    },
    {
      id: 4,
      title: "Shoorah Pods",
      description: "Listen to 3 Shoorah Pods - 50pts",
    },
  ];
  const navigate = useNavigate();
  const [Id, setId] = useState("");
  const [info, setInfo] = useState(null);
  const [open, setOpen] = useState(false);
  const [rewards, setRewards] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isOpen2, setIsOpen2] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [challanges, setChallanges] = useState([]);
  const { userType } = JSON.parse(localStorage.getItem("userData"));
  const [selectedOption, setSelectedOption] = useState("Date Created");

  const handleDelete = async (id) => {
    setLoading(true);
    const res = await Api.deleteChallange(id);
    if (res?.data?.meta?.code === 200) {
      successToast(res?.data?.meta?.message);
      fetchChallanges();
    } else {
      setLoading(false);
    }
  };

  const cardList = [
    <DashboardInfoCard
      icon={<Icons.wellPointsIcon />}
      title={"Total Wellpoints"}
      value="3,222"
    />,
    <DashboardInfoCard
      icon={<Icons.targetIcon />}
      title={"Total Challenges"}
      value="24"
    />,
    <DashboardInfoCard
      icon={<Icons.rewardIcon />}
      title={"Total Rewards"}
      value="18"
    />,
    <DashboardInfoCard
      icon={<Icons.badgeIcon />}
      title={"Total Badges"}
      value="09"
    />,
  ];

  const fetchChallanges = async () => {
    setLoading(true);
    const query = `page=1&status=1&limit=6`;
    const res = await Api.getChallanges(query);
    if (res?.data?.meta?.code === 200) {
      setChallanges(res?.data?.data);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };
  const fetchRewards = async () => {
    setLoading(true);
    const query = `page=1&status=1&limit=6`;
    const res = await Api.getRewards(query);
    if (res?.data?.meta?.code === 200) {
      setRewards(res?.data?.data);
      setLoading(false);
    } else {
      setLoading(false);
    }
  };

  const fetchInfo = async () => {
    if (userType === 4 || userType === 3) {
      try {
        const response = await CompanyApi.getInfoData("challanges");
        if (response?.data?.meta?.code === 200) {
          if (response?.data?.data?.tutorialsData?.length > 0) {
            setOpen(true);
            setInfo(response?.data?.data);
          } else {
            setOpen(false);
            errorToast("Tutorial not found");
          }
        } else {
          setInfo(null);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  useEffect(() => {
    if (userType === 0 || userType === 1) {
      fetchChallanges();
      // fetchRewards();
    }
  }, []);

  return (
    <div className="mx-auto max-w-[1640px] hide-scrollbar font-work-sans">
      {loading && <Loader />}
      <div className="font-work-sans lg:ps-5">
        <Topbar
          title="Challenges"
          infoBtn={true}
          setOpen={setOpen}
          fetchInfo={fetchInfo}
        />
        <div className="flex sm:justify-between flex-wrap gap-5 items-center lg:mt-10">
          <SearchInput
            id="searchKey"
            name="searchKey"
            type="text"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            placeholder="Search"
          />
          <div className="flex flex-wrap items-center gap-3">
            <div className="flex justify-center items-center w-full sm:w-[170px] h-[40px] text-[14px] border border-shoorah-lightBlack rounded-[100px] dark:border-shoorah-darkBg dark:text-shoorah-darkBg">
              <div className="relative inline-block text-left">
                <button
                  type="button"
                  onClick={() => setIsOpen2(!isOpen2)}
                  className="inline-flex justify-between items-center w-full px-3 py-2 text-sm font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg focus:outline-none"
                >
                  {selectedOption}
                  <svg
                    className={`transform transtion-transform ml-0 sm:ml-3 ${
                      isOpen2 ? "rotate-180" : "rotate-0"
                    }`}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.28 9.9668L12.9333 14.3135C12.42 14.8268 11.58 14.8268 11.0666 14.3135L6.71997 9.9668"
                      stroke="#0B1D2E"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="stroke-shoorah-lightBlack dark:stroke-shoorah-darkBg"
                    />
                  </svg>
                </button>
              </div>
            </div>
            <div
              className="flex flex-row relative justify-center items-center w-full sm:w-[170px] sm:p-0 px-4 h-[40px] bg-[#1F1F1F] text-[16px] rounded-[100px] text-[#F4F4F4] cursor-pointer"
              onClick={() => setIsOpen(!isOpen)}
            >
              <div className="relative inline-block text-left">
                <button className="flex flex-row items-center" type="button">
                  Create New
                  <svg
                    className={`transform transtion-transform ml-0 sm:ml-2 ${
                      isOpen ? "rotate-180" : "rotate-0"
                    }`}
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M17.28 9.9668L12.9333 14.3135C12.42 14.8268 11.58 14.8268 11.0666 14.3135L6.71997 9.9668"
                      stroke="#0B1D2E"
                      strokeMiterlimit="10"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      className="stroke-shoorah-darkBg"
                    />
                  </svg>
                </button>

                {isOpen && (
                  <div className="absolute -left-20 top-8 z-10 mt-1 w-[220px] bg-white divide-y divide-shoorah-gray1 border-[1.5px] dark:border-shoorah-darkBorder dark:bg-shoorah-darkBgTabColor border-shoorah-gray1 rounded-lg">
                    <ul className="py-[14px] text-[16px] font-medium text-shoorah-lightBlack dark:text-shoorah-darkBg w-full">
                      <li>
                        <button
                          onClick={() =>
                            navigate(
                              getPathForSurvey(
                                "/team-challanges/add-edit-weekly-challenges"
                              )
                            )
                          }
                          className="block px-5 py-2 w-full text-left hover:bg-gray-100 dark:hover:bg-shoorah-darkBgColor"
                        >
                          New Weekly Challenge
                        </button>
                      </li>
                      <li className="w-[calc(100%-40px)] h-[1px] bg-shoorah-gray1 mx-auto my-1"></li>
                      <li>
                        <button
                          onClick={() =>
                            navigate(
                              getPathForSurvey(
                                "/team-challanges/add-edit-rewards?tab=1"
                              )
                            )
                          }
                          className="block px-5 py-2 w-full text-left hover:bg-gray-100 dark:hover:bg-shoorah-darkBgColor"
                        >
                          New Shoorah Reward
                        </button>
                      </li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
        <div className="grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 grid-cols-1 h-auto gap-4 md:mt-6 mt-5">
          {cardList.map((item, index) => (
            <React.Fragment key={index}>{item}</React.Fragment>
          ))}
        </div>
        <div className="flex flex-col h-fit bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
          <div className="flex flex-row justify-between lg:mb-8 mb-5 items-center">
            <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
              Recent Challenges
            </p>
            <Link
              to={getPathForSurvey("/team-challanges/view-all-challenges")}
              className="lg:text-[14px] text-[10px] leading-9 font-bold text-shoorah-lightBlack dark:text-shoorah-darkBg"
            >
              View All
            </Link>
          </div>
          <div className="h-fit gap-4 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-shoorah-borderGray rounded-2xl">
            {challanges?.map((item, index) => (
              <div key={index}>
                <TeamCard
                  item={item}
                  Id={Id}
                  setId={setId}
                  handleDelete={handleDelete}
                />
              </div>
            ))}
          </div>
        </div>
        <div className="flex flex-col h-fit bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl my-5 lg:p-6 p-4 pb-8">
          <div className="flex flex-row justify-between lg:mb-8 mb-5 items-center">
            <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
              Weekly Challenges
            </p>
            <div className="flex items-center gap-4">
              <Link
                to={getPathForSurvey("/team-challanges/view-all-challenges")}
                className="lg:text-[14px] text-[10px] leading-9 font-bold text-shoorah-lightBlack dark:text-shoorah-darkBg"
              >
                View All
              </Link>

              <Link
                to={getPathForSurvey(
                  "/team-challanges/add-edit-weekly-challenges"
                )}
                className="lg:text-[14px] text-[10px] leading-4 text-shoorah-sidebarBackground py-2 px-4 bg-shoorah-normanGray dark:bg-shoorah-darkBg rounded-[75px]"
              >
                Create New Weekly Challenge
              </Link>
            </div>
          </div>
          <div className="grid grid-cols-1 gap-4">
            <div className="p-4 rounded-2xl border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBg">
              <div className="flex flex-row justify-between lg:mb-8 mb-5 items-center">
                <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
                  Week 5
                </p>
                <Link
                  to={getPathForSurvey(
                    `/team-challanges/add-edit-challenges?id=${"11"}`
                  )}
                  className="lg:text-[14px] text-[10px] leading-9 font-bold text-shoorah-lightBlack dark:text-shoorah-darkBg"
                >
                  <img
                    src={Dots}
                    alt="Dots icon"
                    className="w-6 h-6 block dark:hidden"
                  />
                  <img
                    src={ActiveDots}
                    alt="Dots icon"
                    className="w-6 h-6 hidden dark:block"
                  />
                </Link>
              </div>
              <div className="h-fit gap-4 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-shoorah-borderGray rounded-2xl">
                {challanges?.slice(0, 3)?.map((item, index) => (
                  <div key={index}>
                    <TeamCard
                      item={item}
                      Id={Id}
                      setId={setId}
                      handleDelete={handleDelete}
                      options={false}
                    />
                  </div>
                ))}
              </div>
            </div>
            <div className="p-4 rounded-2xl border-[1.5px] border-shoorah-borderGray dark:border-shoorah-darkBg">
              <div className="flex flex-row justify-between lg:mb-8 mb-5 items-center">
                <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
                  Week 4
                </p>
                <Link
                  to={getPathForSurvey(
                    `/team-challanges/add-edit-challenges?id=${"11"}`
                  )}
                  className="lg:text-[14px] text-[10px] leading-9 font-bold text-shoorah-lightBlack dark:text-shoorah-darkBg"
                >
                  <img
                    src={Dots}
                    alt="Dots icon"
                    className="w-6 h-6 block dark:hidden"
                  />
                  <img
                    src={ActiveDots}
                    alt="Dots icon"
                    className="w-6 h-6 hidden dark:block"
                  />
                </Link>
              </div>
              <div className="h-fit gap-4 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-shoorah-borderGray rounded-2xl">
                {challanges?.slice(0, 3)?.map((item, index) => (
                  <div key={index}>
                    <TeamCard
                      item={item}
                      Id={Id}
                      setId={setId}
                      handleDelete={handleDelete}
                      options={false}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
        <div className="flex flex-col h-fit bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-[1.5px] border-shoorah-borderGray lg:rounded-2xl rounded-xl lg:mt-5 lg:mb-10 mt-5 lg:p-6 p-4 pb-8">
          <div className="flex flex-row justify-between lg:mb-8 mb-5 items-center">
            <p className="lg:text-[24px] text-[18px] text-shoorah-lightBlack dark:text-shoorah-darkBg leading-9 font-medium">
              Shoorah Rewards
            </p>
            <Link
              to={getPathForSurvey("/team-challanges/view-all-rewards")}
              className="lg:text-[14px] text-[10px] leading-9 font-bold text-shoorah-lightBlack dark:text-shoorah-darkBg"
            >
              View All
            </Link>
          </div>
          <div className="h-fit gap-4 grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1 bg-white dark:bg-shoorah-darkBgTabColor dark:border-shoorah-darkBorder border-shoorah-borderGray rounded-2xl">
            {rewardList?.map((item, index) => (
              <div key={index}>
                <TeamCard
                  index={index}
                  item={item}
                  Id={Id}
                  setId={setId}
                  button={true}
                  handleDelete={handleDelete}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <InfoPopup
        open={open}
        data={info}
        title="Challanges"
        handleClose={() => setOpen(false)}
      />
    </div>
  );
};

export default ChallangesDashboard;
